import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { priceTransformer } from 'utils';
import { Percent } from '@mui/icons-material';
import { env } from 'constants';
import Skeleton from './Skeleton';

function Price({
  price,
  discountedPrice,
  horizontal,
  showPercent,
  showZero = false,
  priceSx,
  priceVariant = 'body-lg',
  discountedPriceVariant = 'body-md',
  ...props
}) {
  const discounted = Boolean(discountedPrice) && +price !== +discountedPrice;
  return (
    <Stack direction={horizontal ? 'row' : 'column'} spacing={horizontal ? 1 : 0} {...props}>
      {
        discounted && showPercent && (
          <Chip
            label={(
              <Typography variant="body-caption">
                {Math.round((100 * (price - discountedPrice)) / price)}
                <Percent sx={{ fontSize: '12px' }} />
              </Typography>
            )}
            size="small"
            color="primary"
          />
        )
      }
      <Stack direction={horizontal ? 'row-reverse' : 'column'} alignItems={horizontal ? 'center' : 'end'} spacing={horizontal ? 1 : 0}>
        {discounted && (
          <Typography variant={priceVariant}>{priceTransformer(discountedPrice)}</Typography>
        )}

        <Typography
          lineHeight="20px"
          variant={discounted ? discountedPriceVariant : priceVariant}
          sx={{
            color: discounted ? (env.IS_CATERING ? 'text.disabled' : 'error.main') : priceSx?.color,
            textDecoration: discounted ? 'line-through' : undefined,
            fontWeight: discounted ? 400 : 500,
            ...priceSx,
          }}
        >
          {+price === 0 && !showZero ? null : priceTransformer(price)}
        </Typography>
      </Stack>
    </Stack>
  );
}

function PriceSkeleton() {
  return (
    <Skeleton>
      <Price price={Skeleton.props.price()} />
    </Skeleton>
  );
}

export default Skeleton.withSkeleton(Price, PriceSkeleton);
